import './App.css';
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import Success from "./Success";
import Pricing from "./Pricing";
import Trial from "./Trial";
import React, {useState} from "react";
import Checkout from "./Checkout";
import EmailCapture from "./EmailCapture";
import Reload from "./Reload";
import { createTheme, ThemeProvider } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const theme = createTheme({
  typography: {
    fontFamily: [
      'San Francisco',
      'Helvetica Neue',
      'Helvetica',
      'Arial',
      'sans-serif'
    ].join(','),
  },
});

function App() {
  const [packages, setPackages] = useState('');
  const [email, setEmail] = useState('');
  const [teamSize, setTeamSize] = useState(1);
  const [frequency, setFrequency] = useState('month');
  const [subscriptionType, setSubscriptionType] = useState('pro');

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Header />
        <Routes>
          <Route path='/' element={<Pricing teamSize={teamSize}
                                            setTeamSize={setTeamSize}
                                            frequency={frequency}
                                            setFrequency={setFrequency}
                                            setSubscriptionType={setSubscriptionType} />} />
          <Route path='/email' element={<EmailCapture email={email} setEmail={setEmail}
                                                    nextPath="/checkout"
                                                    showBackButton={true} />} />
          <Route path='/trial' element={<Trial><EmailCapture email={email} setEmail={setEmail}
                                                    nextPath="/trial/package" /></Trial>} />
          <Route path='/trial/package' element={<Trial><Checkout checkoutType='TRIAL'
                                                    subscriptionType={subscriptionType}
                                                    teamSize={teamSize}
                                                    frequency={frequency}
                                                    packages={packages} setPackages={setPackages}
                                                    email={email} /></Trial>} />
          <Route path='/reload/:data' element={<Reload setPackages={setPackages}
                                                       setTeamSize={setTeamSize}
                                                       setFrequency={setFrequency}
                                                       setSubscriptionType={setSubscriptionType} />} />
          <Route path='success/:token' element={<Success />} />
          <Route path='checkout' element={<Checkout checkoutType='SALE'
                                                    subscriptionType={subscriptionType}
                                                    teamSize={teamSize}
                                                    frequency={frequency}
                                                    packages={packages} setPackages={setPackages}
                                                    email={email}
                                                    showBackButton={true}
          />} />
        </Routes>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;
